<template>
  <div class="h-full relative w-full" @drop.prevent="onDrop($event, 1)" @dragover.prevent @dragenter.prevent>
    <!-- <div @click="copyImages()">ccccccc</div> -->
    <div v-if="post">

      <div class="mt-12 px-8 max-w-[800px] mx-auto mb-12">
        <dl class="divide-y divide-gray-100">
          <div class="pb-8">
            <a target="_blank" class="px-4 py-2 text-sm font-medium text-gray-900 rounded-lg border bg-gray-100" :href="`https://getdbt.com/blog/${post.slug}`">Open Live Blog Post</a>
          </div>
          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0" @click="copyRegular(post.title)">
            <dt class="text-sm font-medium leading-6 text-gray-900">Title</dt>
            <dd class="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <span class="flex-grow">{{ post.title }}</span>
              <span class="ml-4 flex-shrink-0">
                <button type="button"  class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Copy</button>
              </span>
            </dd>
          </div>
          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0" @click="copyRegular(post.slug)">
            <dt class="text-sm font-medium leading-6 text-gray-900">Slug</dt>
            <dd class="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <span class="flex-grow">{{ post.slug }}</span>
              <span class="ml-4 flex-shrink-0">
                <button type="button"  class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Copy</button>
              </span>
            </dd>
          </div>
          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0" @click="copyRegular(post.date)" >
            <dt class="text-sm font-medium leading-6 text-gray-900">Date</dt>
            <dd class="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <span class="flex-grow">{{ post.date }}</span>
              <span class="ml-4 flex-shrink-0">
                <button type="button" class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Copy</button>
              </span>
            </dd>
          </div>
          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Authors</dt>
            <dd class="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <span class="flex-grow"><span @click="copyRegular(auth)" v-for="auth in post.authors">{{auth}}, </span></span>
<!--               <span class="ml-4 flex-shrink-0">
                <button type="button" @click="copyRegular(post.title)" class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Update</button>
              </span> -->
            </dd>
          </div>
          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Category</dt>
            <dd class="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <span class="flex-grow">{{post.category}}</span>
<!--               <span class="ml-4 flex-shrink-0">
                <button type="button" @click="copyRegular(post.title)" class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Update</button>
              </span> -->
            </dd>
          </div>
          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0"  @click="copyRegular(post.image)">
            <dt class="text-sm font-medium leading-6 text-gray-900">Featured Image</dt>
            <dd class="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <span class="flex-grow">{{post.image}}</span>
              <span class="ml-4 flex-shrink-0">
                <button type="button" class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Copy</button>
              </span>
            </dd>
          </div>
          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0" @click="copyRegular(post.description)">
            <dt class="text-sm font-medium leading-6 text-gray-900">Description</dt>
            <dd class="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <span class="flex-grow truncate">{{post.description}}</span>
              <span class="ml-4 flex-shrink-0">
                <button type="button"  class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Copy</button>
              </span>
            </dd>
          </div>


          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0" @click="copyBody(post.body)">
            <dt class="text-sm font-medium leading-6 text-gray-900">Post Content</dt>
            <dd class="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <span class="flex-grow truncate">{{post.content?.slice(0, 200)}}...</span>
              <span class="ml-4 flex-shrink-0">
                <button type="button"  class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Copy</button>
              </span>
            </dd>
          </div>
          <div class="p-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-0" v-if="post.codes?.length > 0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Post Code</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <ul role="list" class="divide-y divide-gray-100 rounded-md border border-gray-200">
                <li v-for="code in post.codes" class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6" @click="copyCode(code.htmlContent)">
                  <div class="flex w-0 flex-1 items-center">
                    <div class="ml-4 flex min-w-0 flex-1 gap-2">
                      <span class="truncate font-medium"><span class="font-bold pr-4">{{ code.type }}:  </span> {{ code.content }}</span>
                      <!-- <span class="flex-shrink-0 text-gray-400">2.4mb</span> -->
                    </div>
                  </div>
                  <div class="ml-4 flex flex-shrink-0 space-x-4">
                    <button type="button"  class="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500">Copy</button>
                  </div>
                </li>
              </ul>
            </dd>
          </div>
        </dl>
      </div>
      <div v-html="post.html" class="border-t prose max-w-[950px] mx-auto px-8 py-12">
      </div>
    </div>
    <div v-else class=" pt-24">
      <div class="text-center mx-auto border-2 rounded-xl border-dashed border-gray-300 w-[500px] p-20">
        <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
        </svg>
        <h3 class="mt-2 text-sm font-semibold text-gray-900">No post loaded</h3>
        <p class="mt-1 text-sm text-gray-500">Drag a markdown file anywhere on the page to load its data.</p>
      </div>
    </div>
<!--     <div>
      <button @click="copyImages()">Copy Images</button>
      <button @click="copyDataImages()">Copy Base64 Images</button>
    </div> -->
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { marked } from 'marked'
import { loadFront } from 'yaml-front-matter'
import dayjs from 'dayjs'

const post = ref(null)
const imageList = ref([])

const uniqueImageList = computed(()=>{
  const u = [...new Set(imageList.value)]
  u.sort((a,b)=>{
    return a > b ? 1 : -1
  })
  return u.filter(img => {
    return img.indexOf('data:image') == -1
  })
})

const dataImageList = computed(()=>{
  const u = [...new Set(imageList.value)]
  u.sort((a,b)=>{
    return a > b ? 1 : -1
  })
  return u.filter(img => {
    return img.indexOf('data:image') > -1
  })
})

function copyImages(){
  let copyString = ''
  uniqueImageList.value.forEach(img => {
    copyString += formatImages(img) + '\n'
  })
  console.log(copyString)
  navigator.clipboard.writeText(copyString)
}

function copyDataImages(){
  console.log(dataImageList.value)
  let copyString = ''
  dataImageList.value.forEach(img => {
    copyString += img + '\n'
  })
  console.log(copyString)
  navigator.clipboard.writeText(copyString)
}

function formatImages(img) {
  if (img.indexOf('http://') >= 0 || img.indexOf('https://') >= 0) {
    return img
  } else {
    return 'https://getdbt.com' + img
  }
}

function copyRegular(data) {
  navigator.clipboard.writeText(data)
}

function copyCode(data) {
  navigator.clipboard.write([new ClipboardItem({
    'text/plain': new Blob([data], {type: 'text/plain'}),
    'text/html': new Blob([data], {type: 'text/html'})
  })])
}

function copyBody(data) {
  navigator.clipboard.write([new ClipboardItem({
    'text/plain': new Blob([data.innerText], {type: 'text/plain'}),
    'text/html': new Blob([data.innerHTML], {type: 'text/html'})
  })])
}


async function onDrop(event) {
  // var _Files = [];

  // if (event.dataTransfer.items) {
  //   for (var i = 0; i < event.dataTransfer.items.length; i++) {
  //     if (event.dataTransfer.items[i].kind === 'file') {
  //       var file = event.dataTransfer.items[i].getAsFile();
  //       _Files.push(file)
  //     }
  //   }
  // } else {
  //   for (var i = 0; i < event.dataTransfer.files.length; i++) {
  //     _Files.push(files[i])
  //   }
  // }

  // _Files.forEach(async(file) => {
  //   const text = await file.text()
  //   const config = loadFront(text)
  //   if (config.image) {
  //     imageList.value.push(config.image)
  //   }
  //   const content = marked.parse(config.__content)
  //   const parser = new DOMParser()
  //   const htmlDoc = parser.parseFromString(content, 'text/html')
  //   const imgs = htmlDoc.querySelectorAll('img')
  //   for (let i = 0; i < imgs.length; i++) {
  //     let src = imgs[i].src
  //     src = src.replace('http://localhost:8080','');
  //     imageList.value.push(src)
  //   }
  // })

  // console.log(imageList.value)

  // return 
  const file = await event.dataTransfer.files[0]
  const text = await event.dataTransfer.files.item(0).text()
  const config = loadFront(text)
  console.log(config)
  let content = marked.parse(config.__content)
  content = content.replaceAll('{:target=&quot;_blank&quot; rel=&quot;noopener noreferrer&quot;}', '')
  content = content.replaceAll('{:target=&quot;_blank&quot;}', '')
  content = content.replaceAll('{rel=&quot;noopener noreferrer&quot;}', '')

  const parser = new DOMParser()
  const htmlDoc = parser.parseFromString(content, 'text/html')
  const imgs = htmlDoc.querySelectorAll('img')

  for (var i = 0; i < imgs.length; i++) {
    let src = imgs[i].src
    const newSpan = document.createElement("div")
    if (src.indexOf('localhost:8080') == -1 && (src.indexOf('https://') > -1 || src.indexOf('http://') > -1)) {
      newSpan.innerHTML = `<b>********* EXTERNAL IMAGE REPLACE *********</b><br><b>file:</b> ${src}<br><b>alt:</b> ${imgs[i].alt || 'none'}<br><b>********* EXTERNAL IMAGE REPLACE *********</b>`
    } else {
      src = src.split('/').slice(-1)
      newSpan.innerHTML = `<b>********* INTERNAL IMAGE REPLACE *********</b><br><b>file:</b> ${src}<br><b>alt:</b> ${imgs[i].alt || 'none'}<br><b>********* INTERNAL IMAGE REPLACE *********</b>`
    }
    imgs[i].parentNode.insertBefore(newSpan, imgs[i].nextSibling)
  }

  if (!config.slug) {
    config.slug = file?.name?.slice(11, -3)
  }

  const cleanAuthors = config.authors?.map(auth => {
    let string = auth
    if (string.indexOf('_authors/') > -1) {
      string = string.replace('_authors/', '')
    }
    if (string.indexOf('.md') > -1) {
      string = string.replace('.md', '')
    }
    string = string.replace('-', ' ')
    return string
  })


  let cleanCategory = config.category || ""

  if (cleanCategory.indexOf('_categories/') > -1) {
    cleanCategory = cleanCategory.replace('_categories/', '')
  }
  if (cleanCategory.indexOf('.md') > -1) {
    cleanCategory = cleanCategory.replace('.md', '')
  }
  cleanCategory = cleanCategory.replace('-', ' ')

  const needed = {
    title: config.title,
    date: dayjs(config.date).format('YYYY-MM-DD hh:mm') || '',
    slug: config.slug || '',
    image: config.image, 
    content: config.__content,
    description: config.description || '',
    featured: config.image || 'NA',
    authors: cleanAuthors || [],
    category: cleanCategory || '',
    raw: text,
    html: content,
    codes: [],
  }

  const codes = htmlDoc.querySelectorAll('code')
  for (var i = 0; i < codes.length; i++) {
    const classes = codes[i].classList
    let codeType = 'DEFAULT'

    if (classes.contains('language-yaml')){
      codeType = 'YAML'
    } else if (classes.contains('language-python')){
      codeType = 'PYTHON'
    } else if (classes.contains('language-sql')){
      codeType = 'SQL'
    } else if (classes.contains('language-json')){
      codeType = 'JSON'
    } else if (classes.contains('language-markdown')){
      codeType = 'MARKDOWN'
    }

    needed.codes.push({type: codeType, content: codes[i].innerText, htmlContent: "<pre><code>" + codes[i].innerHTML + "</code></pre>" })

    const text = `
    
    <b><br> START ${codeType} CODE:<br></b>


    `

    const text2 = `
    
    <b><br> END ${codeType} CODE<br></b>


    `

    codes[i].insertAdjacentHTML('afterbegin', text)
    codes[i].insertAdjacentHTML('beforeend', text2)
  }

  needed.body = htmlDoc.body
  post.value = needed
  console.log(needed)
}


</script>
